import React, { useEffect, useState } from 'react';
import { gsap } from 'gsap';
import './LoadingScreen.css';

const LoadingScreen = ({ progress = 0, onComplete }) => {
    const [showSecondText, setShowSecondText] = useState(false);

    useEffect(() => {
        // Show second text when progress reaches 50%
        if (progress >= 50 && !showSecondText) {
            setShowSecondText(true);
        }
    }, [progress, showSecondText]);

    useEffect(() => {
        if (progress >= 100 && onComplete) {
            // Optional callback if parent wants to know when the animation finishes
            gsap.to('.loading-screen', {
                opacity: 0,
                duration: 0.5,
                onComplete: () => {
                    onComplete();
                }
            });
        }
    }, [progress, onComplete]);

    const clampedProgress = Math.min(100, progress);

    return (
        <div className="loading-screen">
            <div className="loading-dissolve">
                {Array.from({ length: 96 }).map((_, i) => (
                    <div
                        key={i}
                        className="loading-dissolve-cell"
                        style={{ animationDelay: `${(i * 11) % 240}ms` }}
                    />
                ))}
            </div>
            <div className="loading-content">
                <div className="loading-text-container">
                    <h1 className={`loading-title ${showSecondText ? 'fade-out' : ''}`}>
                        Jacob Faulkner
                    </h1>
                    <h1 className={`loading-subtitle ${showSecondText ? 'fade-in' : ''}`}>
                        Creative Technologist
                    </h1>
                </div>
                <div className="loading-bar-container">
                    <div className="loading-bar" style={{ width: `${clampedProgress}%` }}></div>
                </div>
                <p className="loading-text">{Math.round(clampedProgress)}%</p>
            </div>
        </div>
    );
};

export default LoadingScreen;